import { Validators } from '@angular/forms';
import { BaseForm } from './base.form';
import { Note, NoteCategory } from '../models/note.model';
import { StringFormControl } from './form-controls/string-form-control';

export class NoteForm extends BaseForm<Note> {
  constructor(note?: Note, options?: { isRequired?: boolean }) {
    super({
      // Notes Text. Allow Emojis and other special characters
      text: new StringFormControl(
        null,
        [Validators.required],
        { sanitizeOptions: { allowedCharacters: null, removeEmojis: false } },
      ),

      // Category selection
      category: new StringFormControl(NoteCategory.OTHER, [Validators.required]),

    });

    if (note) {
      this.patchValue(note);
    }
  }
}
